import React, { useEffect, useState } from 'react';
import { analyticsEnabled, getStoredConsent, setConsent } from '../lib/analytics';

const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (analyticsEnabled() && !getStoredConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div className="v2-consent" role="dialog" aria-label="Privacy & analytics consent">
      <p className="v2-consent-text">
        This site uses privacy-friendly analytics to understand traffic. No ads, no
        cross-site tracking.{' '}
        <a href="/privacy.html" className="v2-consent-link">Learn more</a>.
      </p>
      <div className="v2-consent-actions">
        <button type="button" className="v2-consent-decline" onClick={() => choose(false)}>
          Decline
        </button>
        <button type="button" className="v2-consent-accept" onClick={() => choose(true)}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
